module.exports = __webpack_public_path__ + "media/coffee-preferences/roast_medium-c7ea5379.png";